import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../../utils";
import { GetAllM24EmessiFiltersDTO, GetAllM24EmessiResponseData } from "./dataService/dto";
import { MonitoringM24EmessiService, NewMonitoringM24EmessiService } from "./dataService/service";

interface MonitoringM24EmessiState {
    // FILTERS
    GetAllM24EmessiFilters: GetAllM24EmessiFiltersDTO
    getAllM24EmessiStatus: PromiseStatuses
    GetAllM24EmessiResponse?: GetAllM24EmessiResponseData[]

}

const initialState: MonitoringM24EmessiState = {

    GetAllM24EmessiFilters: {
        itemsPerPage: 500,
        page: 0
    },

    getAllM24EmessiStatus: 'idle',
}

export const GetAllM24Emessi = createAsyncThunk(
    'monitoringM24Open/GetAllM24Emessi',
    async (filters: GetAllM24EmessiFiltersDTO, thunkApi): Promise<GetAllM24EmessiResponseData[]> => {
        const monitoringM24EmessiService = NewMonitoringM24EmessiService()

        return monitoringM24EmessiService.GetAllM24Emessi(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const MonitoringM24EmessiSlice = createSlice({
    name: 'MonitoringM24EmessiSlice/slice',
    initialState,
    reducers: {
        // FILTERS
        setGetAllM24EmessiFiltersItemsPerPage: (state, action) => {
            state.GetAllM24EmessiFilters.itemsPerPage = action.payload
        },
        setGetAllM24EmessiFiltersPage: (state, action) => {
            state.GetAllM24EmessiFilters.page = action.payload
        },
        setGetAllM24EmessiFiltersOrder: (state, action) => {
            state.GetAllM24EmessiFilters.order = action.payload
        },
        setGetAllM24EmessiFiltersSort: (state, action) => {
            state.GetAllM24EmessiFilters.sort = action.payload
        },
        setGetAllM24EmessiStartingDate: (state, action) => {
            state.GetAllM24EmessiFilters.from = action.payload
        },
        setGetAllM24EmessiYear: (state, action) => {
            state.GetAllM24EmessiFilters.year = action.payload
        },
        setGetAllM24EmessiRegion: (state, action) => {
            state.GetAllM24EmessiFilters.region = action.payload
        },
        setGetAllM24EmessiSot: (state, action) => {
            state.GetAllM24EmessiFilters.sot = action.payload
        },
        setGetAllFaseAvvioEndingDate: (state, action) => {
            state.GetAllM24EmessiFilters.to = action.payload
        },
        resetGetAllM24EmessiFilters: (state) => {
            state.GetAllM24EmessiFilters = {
                itemsPerPage: 500,
                page: 0
            }
        },
    },
    extraReducers(builder) {
        builder

            // GET ALL
            .addCase(GetAllM24Emessi.pending, (state) => {
                state.getAllM24EmessiStatus = 'loading'
            })
            .addCase(GetAllM24Emessi.fulfilled, (state, action) => {
                state.getAllM24EmessiStatus = 'successfully'
                state.GetAllM24EmessiResponse = action.payload
            })
            .addCase(GetAllM24Emessi.rejected, (state) => {
                state.getAllM24EmessiStatus = 'failed'
            })

    },
})

export const {
    setGetAllFaseAvvioEndingDate,
    setGetAllM24EmessiStartingDate,
    setGetAllM24EmessiFiltersItemsPerPage,
    setGetAllM24EmessiRegion,
    setGetAllM24EmessiSot,
    setGetAllM24EmessiFiltersOrder,
    setGetAllM24EmessiFiltersPage,
    setGetAllM24EmessiFiltersSort,
    setGetAllM24EmessiYear,
    resetGetAllM24EmessiFilters
} = MonitoringM24EmessiSlice.actions

export default MonitoringM24EmessiSlice.reducer